import { Box, Image } from '@chakra-ui/react';

import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';

export default function CaptionCarousel({ images, alt }) {
  return (
    <Box
      position={'relative'}
      width={{ sm: '10rem', md: '13rem' }}
      height={{ sm: '10rem', md: 'auto' }}
      overflow={'hidden'}
      bg={'white.200'}
    >
      <Carousel
        infiniteLoop
        showArrows={false}
        showStatus={false}
        showIndicators={true}
        showThumbs={false}
        autoPlay
      >
        {images.map((img, i) => (
          <div key={i}>
            <Image
              key={i}
              w={{ sm: '10rem', md: '20rem' }}
              height={{ sm: '15rem', md: '20rem' }}
              position="relative"
              backgroundPosition="center"
              backgroundRepeat="no-repeat"
              backgroundSize="cover"
              src={process.env.PUBLIC_URL + img}
              alt={alt}
            />
          </div>
        ))}
      </Carousel>
    </Box>
  );
}
